export default __webpack_public_path__ + "static/media/eliott.07d6690c.jpg";